import { Box, Button, Flex } from '@chakra-ui/react';
import { camelCase } from 'lodash';
import { CheckIcon } from '~/components/icons';

import { StepperFormNavViewport } from './StepperFormNav.types';

export const StepperFormNavMobile: React.FC<StepperFormNavViewport> = ({
  isLinear,
  isLoading,
  onClick,
  steps,
  stepsState,
  ...boxProps
}) => {
  return (
    <Box
      overflowX="auto"
      as="nav"
      marginX={-3}
      marginBottom={6}
      paddingBottom={4}
      whiteSpace="nowrap"
      {...boxProps}
    >
      {steps.map(({ title }, index) => {
        const { isActive, isDisabled, isRequired, isCompleted, hasError } =
          stepsState[index];
        const isLinearCompleted = isLinear && isCompleted;
        return (
          <Button
            _active={{
              color: 'primary.500',
              fontWeight: 600,
              _before: {
                position: 'absolute',
                top: '100%',
                left: 0,
                width: '48px',
                height: '3px',
                marginTop: 1,
                borderRadius: '8px',
                backgroundColor: 'secondary.500',
                content: '""',
              },
            }}
            _disabled={{ color: 'primary.200' }}
            _hover={{ textDecoration: 'none' }}
            key={`${camelCase(title)}-${index}`}
            position="relative"
            display="inline-block"
            isDisabled={isLoading || isDisabled}
            marginX={3}
            isActive={isActive}
            onClick={() => onClick(index)}
            variant="link"
            color={!isLinear && hasError ? 'error.500' : 'primary.300'}
            fontWeight={isLinearCompleted ? 600 : 400}
          >
            <Flex alignItems="center">
              {title}
              {(isRequired || (!isLinear && hasError)) && '*'}
              {isLinearCompleted && <CheckIcon boxSize={3} marginLeft={1} />}
            </Flex>
          </Button>
        );
      })}
    </Box>
  );
};
